import { computed, Injectable, signal } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

@Injectable({
    providedIn: 'root',
})
export class UnloadWarningService {
    private readonly activeUploads = signal<Set<string>>(new Set<string>());
    public readonly shouldWarn = computed(() => this.activeUploads().size > 0);

    public trackUpload(): string {
        const uniqueId = uuidv4();
        this.updateActiveUploads(uniqueId, 'add');
        return uniqueId;
    }

    public cancelTracking(idToRemove: string): void {
        this.updateActiveUploads(idToRemove, 'remove');
    }

    private updateActiveUploads(id: string, mode: 'add' | 'remove'): void {
        if (mode === 'add') {
            this.activeUploads.update((prev) => {
                const next = new Set(prev);
                next.add(id);
                return next;
            });
        } else {
            this.activeUploads.update((prev) => {
                const next = new Set(prev);
                next.delete(id);
                return next;
            });
        }
    }
}
